export const appTitle = ".MovDb";
// export const API_KEY = "b3ae8fbaf360bb8bec2aa030f5f38b60";
export const appStorageName = "mov-db-favs";
export const catStorageName = "mov-db-category";
export const searchQueryStorageName = "mov-db-search";

export const movieCategories = [
  "popular",
  "now_playing",
  "top_rated",
  "upcoming",
];

export const endPointGetW500Img = "https://image.tmdb.org/t/p/w500/";
export const endPointGetOriginalImg = "https://image.tmdb.org/t/p/original/";
